import { FC } from "react";

export interface OrderlyLogoProps {
  width?: number;
  height?: number;
  className?: string | undefined;
}

export const OrderlyLogo: FC<OrderlyLogoProps> = (props) => {
  const { width = 106, height = 12, className } = props;

  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={`${width}px`}
        height={`${height}px`}
        // stroke="currentColor"
        className={`${className}`}
      >
        <path
          d="M12.1223 9.94118H14.172V7.21984C14.172 5.58454 15.1344 5.12267 16.0343 5.12267C16.1967 5.12267 16.3467 5.13515 16.5592 5.16012V3.43743C16.3592 3.3875 16.1967 3.37502 16.0592 3.37502C15.0719 3.37502 14.4595 4.03663 14.2095 5.06025H14.172V3.44992H12.1223V9.94118Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M20.0743 10.066C21.0367 10.066 21.6991 9.5542 21.874 9.06736V9.94118H23.9237V1.20294H21.874V4.32374C21.6991 3.8369 21.0367 3.32509 20.0743 3.32509C18.7495 3.32509 17.2497 4.29877 17.2497 6.69555C17.2497 9.10481 18.7495 10.066 20.0743 10.066ZM19.1744 6.69555C19.1744 5.54709 19.8618 5.0228 20.5867 5.0228C21.2991 5.0228 21.9615 5.54709 21.9615 6.69555C21.9615 7.844 21.2991 8.3683 20.5867 8.3683C19.8618 8.3683 19.1744 7.844 19.1744 6.69555Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M28.5775 10.066C30.1772 10.066 31.3396 9.24212 31.6395 7.74414H29.8398C29.7273 8.16857 29.4523 8.5181 28.615 8.5181C27.8151 8.5181 27.3151 8.15608 27.2027 7.20736H31.6895C31.7145 7.05756 31.727 6.93273 31.727 6.69555C31.727 4.16146 30.2522 3.32509 28.5775 3.32509C26.8402 3.32509 25.2654 4.24884 25.2654 6.67058C25.2654 9.19219 26.9652 10.066 28.5775 10.066ZM27.2152 6.02146C27.3401 5.27246 27.7651 4.873 28.5275 4.873C29.4648 4.873 29.7523 5.45971 29.7898 6.02146H27.2152Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M33.0563 9.94118H35.106V7.21984C35.106 5.58454 36.0684 5.12267 36.9682 5.12267C37.1307 5.12267 37.2807 5.13515 37.4932 5.16012V3.43743C37.2932 3.3875 37.1307 3.37502 36.9932 3.37502C36.0059 3.37502 35.3935 4.03663 35.1435 5.06025H35.106V3.44992H33.0563V9.94118Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M38.6917 9.94118H40.7414V1.20294H38.6917V9.94118Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M42.5257 10.7401V12.4628C44.538 12.675 45.3753 12.0009 46.2502 9.86628L48.8748 3.44992H46.7751L45.3503 7.33219L43.963 3.44992H41.8758L44.238 9.27957C44.4005 9.66655 44.413 9.86628 44.2755 10.1784C44.163 10.428 43.8756 10.9149 42.5257 10.7401Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M53.3278 9.94118H55.415V4.7232H55.465L58.6145 9.94118H60.8642V1.20294H58.7645V6.55823H58.7145L55.49 1.20294H53.3278V9.94118Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M65.5023 10.066C67.1021 10.066 68.2644 9.24212 68.5644 7.74414H66.7646C66.6522 8.16857 66.3772 8.5181 65.5398 8.5181C64.7399 8.5181 64.24 8.15608 64.1275 7.20736H68.6144C68.6394 7.05756 68.6519 6.93273 68.6519 6.69555C68.6519 4.16146 67.1771 3.32509 65.5023 3.32509C63.7651 3.32509 62.1903 4.24884 62.1903 6.67058C62.1903 9.19219 63.8901 10.066 65.5023 10.066ZM64.14 6.02146C64.265 5.27246 64.6899 4.873 65.4523 4.873C66.3897 4.873 66.6772 5.45971 66.7146 6.02146H64.14Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M72.9557 10.0286C73.3432 10.0286 73.7181 9.97863 74.0306 9.89125V8.38078C73.7431 8.40575 73.6306 8.40575 73.4932 8.40575C72.8308 8.40575 72.7058 8.04373 72.7058 7.59434V5.03528H73.9806V3.44992H72.7058V1.7522H70.6561V3.44992H69.5437V5.03528H70.6561V7.88145C70.6561 9.39192 71.5559 10.0286 72.9557 10.0286Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M76.6619 9.94118H78.974L80.0114 6.17125L81.0487 9.94118H83.3484L85.0481 3.44992H83.1109L82.0986 7.96883H82.0486L80.8862 3.44992H79.124L77.9617 7.96883H77.9117L76.8993 3.44992H74.9746L76.6619 9.94118Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M88.9899 10.066C90.6271 10.066 92.2894 9.07984 92.2894 6.69555C92.2894 4.31126 90.6271 3.32509 88.9899 3.32509C87.3401 3.32509 85.6903 4.31126 85.6903 6.69555C85.6903 9.07984 87.3401 10.066 88.9899 10.066ZM87.6026 6.69555C87.6026 5.54709 88.19 5.0228 88.9899 5.0228C89.7772 5.0228 90.3647 5.54709 90.3647 6.69555C90.3647 7.844 89.7772 8.3683 88.9899 8.3683C88.19 8.3683 87.6026 7.844 87.6026 6.69555Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M93.6155 9.94118H95.6652V7.21984C95.6652 5.58454 96.6275 5.12267 97.5274 5.12267C97.6899 5.12267 97.8399 5.13515 98.0523 5.16012V3.43743C97.8524 3.3875 97.6899 3.37502 97.5524 3.37502C96.565 3.37502 95.9526 4.03663 95.7027 5.06025H95.6652V3.44992H93.6155V9.94118Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          d="M99.2509 9.94118H101.301V8.0687L101.813 7.51944L103.75 9.94118H106L103.063 6.19622L105.662 3.44992H103.425L101.301 5.87166V1.20294H99.2509V9.94118Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          clipRule="evenodd"
          d="M5.46632 0.499939L5.49064 0.499939C6.77322 0.502919 7.94491 0.977342 8.84121 1.7589C8.90473 1.81428 8.8645 1.91592 8.78019 1.91592L2.17677 1.91592C2.09246 1.91592 2.05223 1.81428 2.11575 1.7589C3.01205 0.977342 4.18374 0.502919 5.46632 0.499939Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          clipRule="evenodd"
          d="M3.48861 7.00029C3.45201 6.94816 3.39308 6.91541 3.32934 6.91541L0.683399 6.91541C0.606747 6.91541 0.55086 6.988 0.572611 7.06141C1.19907 9.17581 3.15842 10.7185 5.47851 10.7185C7.79861 10.7185 9.75795 9.17581 10.3844 7.06141C10.4062 6.988 10.3503 6.91541 10.2736 6.91541L7.62773 6.91541C7.56398 6.91541 7.50505 6.94816 7.46845 7.00029C7.02918 7.62591 6.30168 8.03491 5.47853 8.03491C4.65539 8.03491 3.92788 7.62591 3.48861 7.00029Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          clipRule="evenodd"
          d="M7.40486 4.13149C7.45163 4.19224 7.52286 4.23033 7.59958 4.23033L10.2514 4.23033C10.3288 4.23033 10.3848 4.15657 10.3617 4.08282C10.1613 3.4425 9.83817 2.85634 9.41977 2.35184C9.38495 2.30984 9.33293 2.28613 9.27833 2.28613L1.67836 2.28613C1.62376 2.28613 1.57174 2.30984 1.53692 2.35183C1.11852 2.85634 0.795365 3.44249 0.594969 4.08282C0.571886 4.15657 0.627906 4.23033 0.705275 4.23033L3.35712 4.23033C3.43384 4.23033 3.50507 4.19224 3.55184 4.13149C3.99586 3.55477 4.69365 3.18309 5.47835 3.18309C6.26305 3.18309 6.96084 3.55477 7.40486 4.13149Z"
          fill="white"
          fillOpacity="0.54"
        />
        <path
          clipRule="evenodd"
          d="M7.82533 6.54582C7.77525 6.54582 7.74121 6.49484 7.75851 6.44789C7.85477 6.18672 7.90732 5.90444 7.90732 5.60991C7.90732 5.28881 7.84486 4.98229 7.73141 4.70179C7.71228 4.65449 7.74636 4.60162 7.79744 4.60162L10.3986 4.60162C10.4543 4.60162 10.5024 4.64086 10.5124 4.69561C10.566 4.99229 10.594 5.29787 10.594 5.60999C10.594 5.89615 10.5705 6.17683 10.5252 6.45018C10.516 6.5057 10.4675 6.54582 10.4112 6.54582L7.82533 6.54582ZM3.19856 6.44789C3.21586 6.49484 3.18183 6.54582 3.13174 6.54582L0.545874 6.54582C0.489533 6.54582 0.441067 6.5057 0.43187 6.45018C0.386592 6.17683 0.363037 5.89615 0.363037 5.60999C0.363037 5.29787 0.391057 4.99228 0.444722 4.69561C0.454626 4.64086 0.502731 4.60162 0.558433 4.60162L3.15963 4.60162C3.21071 4.60162 3.24479 4.65449 3.22566 4.70179C3.11221 4.98229 3.04975 5.28881 3.04975 5.60991C3.04975 5.90444 3.10231 6.18672 3.19856 6.44789Z"
          fill="white"
          fillOpacity="0.54"
        />
      </svg>
    </div>
  );
};
